import JsonInput from 'components/JsonInput/JsonInput'
import React from 'react'

const ProfileInput = ({formData, handleChange}) => {
  return (
    <div>
      		<JsonInput
						onChange={handleChange}
						type="text"
						fieldName="fullName"
						defaultValue={formData.fullName}
					/>
					<JsonInput
						onChange={handleChange}
						type="text"
						fieldName="about"
						defaultValue={formData.about}
					/>
					<JsonInput
						onChange={handleChange}
						type="text"
						fieldName="designation"
						defaultValue={formData.designation}
					/>
					<JsonInput
						onChange={handleChange}
						type="text"
						fieldName="country"
						defaultValue={formData.country}
					/>
					<JsonInput
						onChange={handleChange}
						type="email"
						fieldName="email"
						defaultValue={formData.email}
					/>
					<JsonInput
						onChange={handleChange}
						type="text"
						fieldName="phone"
						defaultValue={formData.phone}
					/>
					<JsonInput
						onChange={handleChange}
						type="text"
						fieldName="address"
						defaultValue={formData.address}
					/>
					<JsonInput
						onChange={handleChange}
						type="text"
						fieldName="leetcodeUsername"
						defaultValue={formData.leetcodeUsername}
					/>
					<JsonInput
						onChange={handleChange}
						type="text"
						fieldName="codeforcesUsername"
						defaultValue={formData.codeforcesUsername}
					/>
					<JsonInput
						onChange={handleChange}
						type="text"
						fieldName="githubUsername"
						defaultValue={formData.githubUsername}
					/>
					<JsonInput
						onChange={handleChange}
						type="text"
						fieldName="codechefUsername"
						defaultValue={formData.codechefUsername}
					/>
					<JsonInput
						onChange={handleChange}
						type="text"
						fieldName="hackerrankUsername"
						defaultValue={formData.hackerrankUsername}
					/>
					<JsonInput
						onChange={handleChange}
						type="url"
						fieldName="githubUrl"
						defaultValue={formData.githubUrl}
					/>
					<JsonInput
						onChange={handleChange}
						type="url"
						fieldName="linkedinUrl"
						defaultValue={formData.linkedinUrl}
					/>
					<JsonInput
						onChange={handleChange}
						type="url"
						fieldName="instagramUrl"
						defaultValue={formData.instagramUrl}
					/>
					<JsonInput
						onChange={handleChange}
						type="url"
						fieldName="twitterUrl"
						defaultValue={formData.twitterUrl}
					/>
					<JsonInput
						onChange={handleChange}
						type="url"
						fieldName="resumeUrl"
						defaultValue={formData.resumeUrl}
					/>
    </div>
  )
}

export default ProfileInput